import { addMethod, string } from 'yup';

addMethod(string, 'lastname', function (message) {
  return this.test('lastname-test', message, (value) => /^([\p{L}]+[-,. ']*[ ]*)+$/u.test(value ?? 'null'));
});
